import {
  Icons,
  ListItem,
  Select,
  Stack,
  Typography,
} from '@cast/design-system';

import { AccessOption } from '../workloads-list/_types';

import { useSearchCriterion } from '@cast/shared-search-ui';

const ACCESS_FILTER_KEY = 'access';

const options: { value: AccessOption; label: string }[] = [
  { value: AccessOption.ALL, label: 'All' },
  { value: AccessOption.UNRESTRICTED, label: 'Not restricted' },
  { value: AccessOption.RESTRICTED, label: 'Restricted' },
];

export const AccessFilter = () => {
  const { value, setValue, clear } =
    useSearchCriterion<AccessOption>(ACCESS_FILTER_KEY);

  return (
    <Select
      testId="access-filter"
      inputText="Access"
      options={options}
      optionLabel="label"
      optionValue="value"
      value={value}
      onChange={(option) => {
        if (option) {
          setValue?.(option.value);
        } else {
          clear?.();
        }
      }}
      size="sm"
      applySortingWhileSearching={false}
      renderOption={(option, itemProps) => (
        <ListItem {...itemProps}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            columnGap={8}
            sx={{ width: '100%' }}
          >
            <Typography variant="P14R">{option.label}</Typography>
            {option.value === AccessOption.RESTRICTED && (
              <Icons.Lock size={16} />
            )}
          </Stack>
        </ListItem>
      )}
    />
  );
};
